export default class Tixly {
	constructor() {
		document.addEventListener('DOMContentLoaded', () => {
			this.init();
		 });

	}

	init() {
		console.log( 'init tixly' );
		const tixIframe = document.createElement('iframe');
		tixIframe.src = 'https://tickets.mge.nl/nl/itix';
		tixIframe.style.display = 'none';
		tixIframe.style.width = '0';
		tixIframe.style.height = '0';
		tixIframe.style.border = '0';
		document.body.appendChild(tixIframe);

		const userButtons = document.querySelectorAll('.mge-user__toggle');
		const userDropdown = document.querySelector('.mge-user-dropdown');
		const basketButtons = document.querySelectorAll('.mge-basket__toggle');
		const basketDropdown = document.querySelector('.mge-basket-dropdown');

		if (userButtons.length === 0 || !userDropdown) {
			return;
		}

		document.body.appendChild(userDropdown);
		if (basketDropdown) {
			document.body.appendChild(basketDropdown);
		}

		const userNameDropdown = document.querySelector('.js-user-name');
		const cartCount = document.querySelector('.js-cart-count');
		const cartCountBasket = document.querySelector('.js-cart-count-basket');
		const cartItemsContainer = document.querySelector('.js-cart-items');
		const cartItemsContainerBasket = document.querySelector('.js-cart-items-basket');
		const actions = document.querySelector('.js-user-actions');
		const basketActions = document.querySelector('.js-basket-actions');

		// Keep track of which basket button was clicked (for repositioning)
		let activeBasketButton = null;

		// Helper function to position dropdown
		const positionDropdown = (button, dropdown) => {
			if (!button || !dropdown) return;

			const rect = button.getBoundingClientRect();
			const offset = 10;
			const isMobileNavButton = button.closest('.nav-list-mobile') !== null;

			if (isMobileNavButton) {
				// Position dropdown above the mobile nav bar.
				const bottomOffset = window.innerHeight - rect.top + offset;
				dropdown.style.bottom = Math.max(bottomOffset, 0) + 'px';
				dropdown.style.top = 'auto';
				return;
			}

			// Position dropdown below button
			// Right position is set in CSS (30px), so we only need to set top
			dropdown.style.top = (rect.bottom + offset) + 'px';
			dropdown.style.bottom = 'auto';
		};

		// Keep track of which account button was clicked (for repositioning)
		let activeUserButton = null;

		// Account toggles (Mijn MgE)
		userButtons.forEach((button) => {
			button.addEventListener('click', (e) => {
				e.preventDefault();
				e.stopPropagation();

				// Close basket dropdown if open
				if (basketDropdown) {
					basketDropdown.classList.remove('open');
				}

				activeUserButton = button;

				// Position and toggle account dropdown
				positionDropdown(button, userDropdown);
				userDropdown.classList.toggle('open');
			});
		});

		// Basket toggles
		if (basketButtons.length > 0 && basketDropdown) {
			basketButtons.forEach((basketButton) => {
				basketButton.addEventListener('click', (e) => {
					e.preventDefault();
					e.stopPropagation();

					// Close account dropdown if open
					userDropdown.classList.remove('open');

					// Remember which button was clicked
					activeBasketButton = basketButton;

					// Position and toggle basket dropdown
					positionDropdown(basketButton, basketDropdown);
					basketDropdown.classList.toggle('open');
				});
			});
		}

		// Reposition dropdowns on scroll and resize
		let repositionRequestId = null;
		const repositionDropdowns = () => {
			// Use requestAnimationFrame for smooth repositioning during scroll
			if (repositionRequestId !== null) {
				cancelAnimationFrame(repositionRequestId);
			}

			repositionRequestId = requestAnimationFrame(() => {
				if (userDropdown.classList.contains('open')) {
					const buttonToUse = activeUserButton || Array.from(userButtons)
						.filter(btn => {
							const rect = btn.getBoundingClientRect();
							return rect.width > 0 && rect.height > 0 &&
								   rect.top >= 0 &&
								   rect.left >= 0 &&
								   rect.bottom <= window.innerHeight &&
								   rect.right <= window.innerWidth;
						})
						.find(btn => {
							return btn.closest('.nav-actions') !== null;
						}) || Array.from(userButtons).find(btn => {
							const rect = btn.getBoundingClientRect();
							return rect.width > 0 && rect.height > 0;
						});

					if (buttonToUse) {
						positionDropdown(buttonToUse, userDropdown);
					}
				}
				if (basketDropdown && basketDropdown.classList.contains('open')) {
					// Use the button that was clicked, or find the visible one
					const buttonToUse = activeBasketButton || Array.from(basketButtons)
						.filter(btn => {
							const rect = btn.getBoundingClientRect();
							return rect.width > 0 && rect.height > 0 &&
								   rect.top >= 0 &&
								   rect.left >= 0 &&
								   rect.bottom <= window.innerHeight &&
								   rect.right <= window.innerWidth;
						})
						.find(btn => {
							// Prefer button in nav-actions (desktop) over mobile nav
							return btn.closest('.nav-actions') !== null;
						}) || Array.from(basketButtons).find(btn => {
							const rect = btn.getBoundingClientRect();
							return rect.width > 0 && rect.height > 0;
						});

					if (buttonToUse) {
						positionDropdown(buttonToUse, basketDropdown);
					}
				}
				repositionRequestId = null;
			});
		};

		window.addEventListener('scroll', repositionDropdowns, { passive: true });
		window.addEventListener('resize', repositionDropdowns);

		// Close dropdowns when clicking outside
		document.addEventListener('click', (e) => {
			const isUserButton = Array.from(userButtons).some(btn => btn.contains(e.target));
			const isUserDropdown = userDropdown.contains(e.target);
			const isBasketButton = Array.from(basketButtons).some(btn => btn.contains(e.target));
			const isBasketDropdown = basketDropdown && basketDropdown.contains(e.target);

			if (!isUserButton && !isUserDropdown) {
				userDropdown.classList.remove('open');
			}

			if (basketDropdown && !isBasketButton && !isBasketDropdown) {
				basketDropdown.classList.remove('open');
			}
		});

		window.addEventListener('load', () => {
			tixIframe.contentWindow.postMessage('GetSession', 'https://tickets.mge.nl');
		});

		window.addEventListener('message', (event) => {
			if (event.origin !== 'https://tickets.mge.nl') return;
			// if (!eventData) return;

				// cookiesettings - used for favorites
			let expires = '';
			const date = new Date();
			date.setTime(date.getTime() + 30 * 24 * 60 * 60 * 1000); // Set cookie to expire in 30 days
			expires = '; expires=' + date.toUTCString();
			let cookieSetting = expires + '; path=/';

			const eventData = {
				"order": null,
				"user": {
					"id": 3633143,
					"name": "Support",
					"email": "support@eagerly.nl",
					"hash": "662748500c03b84177a06f4bfb3972f6d53ed4b0013dbfd6297745b693821c20",
					"tags": [
						{
							"id": 1836,
							"name": "Marketing",
							"abbr": "MA"
						}
					]
				},
				"profile": "https://tickets.mge.nl/nl/profile/"
			};

			if (eventData.user) {

				let tixUser = eventData.user;
				let tixUserId = tixUser.id; // needed to save favorites
				let tixUserHash = tixUser.hash;

				// set cookies - used for favorites
				let cookieContactId =
					customData && customData.cookieContactId
						? customData.cookieContactId
						: '';
				document.cookie = cookieContactId + '=' + tixUserId + cookieSetting;

				// use this?
				if (tixUserHash) {
					let cookieAuth =
						customData && customData.cookieAuth
							? customData.cookieAuth
							: '';
					document.cookie = cookieAuth + '=' + tixUserHash + cookieSetting;
				}

				// TODO: BA: This sucks, easily spoofed if you just set a custom cookie with userTags, but we're on a time limit.
				// Set a cookie with csv of all user tags, to then check that in the backend
				const cookieTags = tixUser.tags.map(tag => tag.id).join(',');
				if (cookieTags) {
					document.cookie = 'userTags=' + cookieTags + cookieSetting;
				}

			} else {
				let cookieContactId =
					customData && customData.cookieContactId
						? customData.cookieContactId
						: '';
				document.cookie = cookieContactId + '=;' + cookieSetting; // clear cookie;

				let cookieAuth =
					customData && customData.cookieAuth ? customData.cookieAuth : '';
				document.cookie = cookieAuth + '=;' + cookieSetting; // clear cookie;
			}

			this.updateUI(eventData, userNameDropdown, cartCount, cartCountBasket, cartItemsContainer, cartItemsContainerBasket, actions, basketActions);
		});
	}

	updateUI(info, userNameDropdown, cartCount, cartCountBasket, cartItemsContainer, cartItemsContainerBasket, actions, basketActions) {
		const user = info.user;
		const order = info.order;

		if (userNameDropdown) {
			userNameDropdown.textContent = user ? user.name : 'Gast';
		}

		const count = order?.items?.length || 0;
		const countText = count + ' items';

		if (cartCount) {
			cartCount.textContent = countText;
		}
		if (cartCountBasket) {
			cartCountBasket.textContent = countText;
		}

		// Update account dropdown cart items
		if (cartItemsContainer) {
			cartItemsContainer.innerHTML = '';
			if (count > 0) {
				order.items.forEach((item) => {
					const div = document.createElement('div');
					div.className = 'mge-user__cart-item';
					div.textContent = item.name + ' – ' + item.details;
					cartItemsContainer.appendChild(div);
				});
			}
		}

		// Update basket dropdown cart items
		if (cartItemsContainerBasket) {
			cartItemsContainerBasket.innerHTML = '';
			if (count > 0) {
				order.items.forEach((item) => {
					const div = document.createElement('div');
					div.className = 'mge-user__cart-item';
					div.textContent = item.name + ' – ' + item.details;
					cartItemsContainerBasket.appendChild(div);
				});
			}
		}

		// Update account dropdown actions
		if (actions) {
			// console.log( 'actions:' );
			// console.log( actions );
			actions.innerHTML = '';
			if (user) {
				actions.innerHTML += `<a class="btn btn--secondary" role="button" target="_blank" aria-label="Mijn account" href="${info.profile}">Mijn account</a>`;
				actions.innerHTML += `<a class="btn btn--secondary" role="button" target="_blank" aria-label="Uitloggen" href="https://tickets.mge.nl/nl/logout">Uitloggen</a>`;
			} else {
				actions.innerHTML += `<a class="btn btn--secondary" role="button" aria-label="Inloggen" target="_blank" href="${info.profile}">Inloggen</a>`;
			}
		} else {
			console.log('no actions' );
		}

		// Update basket dropdown actions
		if (basketActions) {
			basketActions.innerHTML = '';
			if (count > 0) {
				basketActions.innerHTML += `<a class="btn btn--secondary" role="button" aria-label="Afrekenen" href="${order.url}">Afrekenen</a>`;
			}
		}
	}
}
